module.exports = __webpack_public_path__ + "NandeeshKhyalappa-07c0273d.webp";